import { Link } from 'react-router-dom';
import { PageHeader } from '../ui/PageHeader';
import { Card, Stack } from '../ui/Card';
import { EmptyState } from '../ui/EmptyState';
import { usePageTrail } from '../shell/ShellContext';
import { defineMessages } from '../../i18n/define';
import { useT } from '../../i18n/hooks';

const m = defineMessages({
  levelDistrict: {
    id: 'common.notFound.trailDistrict',
    defaultMessage: 'Район',
    description: 'Уровень первой ступени хлебных крошек на странице «Не найдено»: район',
  },
  districtName: {
    id: 'common.notFound.districtName',
    defaultMessage: 'Бука',
    description: 'Название района (Бука) в хлебных крошках; имя собственное',
  },
  levelScreen: {
    id: 'common.notFound.trailScreen',
    defaultMessage: 'Экран',
    description: 'Уровень второй ступени хлебных крошек на странице «Не найдено»',
  },
  trailName: {
    id: 'common.notFound.trailName',
    defaultMessage: 'Не найден',
    description: 'Название второй ступени хлебных крошек: экран не найден; коротко',
  },
  title: {
    id: 'common.notFound.title',
    defaultMessage: 'Такого экрана нет',
    description: 'Заголовок страницы, открытой по несуществующему адресу',
  },
  purpose: {
    id: 'common.notFound.purpose',
    defaultMessage: 'Адрес не совпал ни с одним разделом.',
    description: 'Подзаголовок страницы «Такого экрана нет»: пояснение, что адрес неверный',
  },
  emptyTitle: {
    id: 'common.notFound.emptyTitle',
    defaultMessage: 'Страница не найдена',
    description: 'Заголовок пустого состояния на странице «Не найдено»',
  },
  emptyReason: {
    id: 'common.notFound.emptyReason',
    defaultMessage: 'проверьте адрес или вернитесь в обзор района',
    description: 'Пояснение пустого состояния на странице «Не найдено» (строчная фраза)',
  },
  back: {
    id: 'common.notFound.back',
    defaultMessage: 'Вернуться в обзор',
    description: 'Ссылка-действие на странице «Не найдено»: вернуться на главную; коротко',
  },
});


export function NotFound() {
  const t = useT();
  usePageTrail([{ level: t(m.levelDistrict), name: t(m.districtName), to: '/' }, { level: t(m.levelScreen), name: t(m.trailName) }]);

  return (
    <Stack>
      <PageHeader title={t(m.title)} purpose={t(m.purpose)} />
      <Card>
        <EmptyState
          compact
          title={t(m.emptyTitle)}
          reason={t(m.emptyReason)}
          action={<Link to="/">{t(m.back)}</Link>}
        />
      </Card>
    </Stack>
  );
}
